import { TeeTime } from './TeeTime'

export function filterTeeTimes(
  teeTimes: TeeTime[],
  startDate: Date,
  endDate: Date,
  startHour: number = 0,
  endHour: number = 23
): TeeTime[] {
  return teeTimes.filter(
    (teeTime) =>
      teeTime.time >= startDate &&
      teeTime.time <= endDate &&
      teeTime.time.getHours() >= startHour &&
      teeTime.time.getHours() <= endHour
  )
}
